import { Link } from "react-router-dom";
import { STAFF_SMS_CONSENT_TEXT } from "@/content/staffSmsConsent";

const inputClass =
  "w-full bg-white/5 border border-white/10 text-white px-4 py-2.5 font-['Manrope'] focus:outline-none focus:border-blue-500/50";
const linkCls =
  "text-blue-400 hover:text-blue-300 underline underline-offset-2";
const boxCls =
  "mt-1 h-4 w-4 shrink-0 rounded-sm border border-white/40 bg-transparent accent-blue-500";

export default function StaffSmsConsentFields({
  phone,
  onPhoneChange,
  smsOptIn,
  onSmsOptInChange,
  acceptedTerms,
  onAcceptedTermsChange,
  showPhone = true,
  showTermsCheckbox = true,
  termsAlreadyAccepted = false,
}) {
  return (
    <div className="space-y-4">
      {showPhone && (
        <div>
          <label className="block text-sm font-['Manrope'] text-white/70 mb-1.5">
            Mobile phone {smsOptIn ? "*" : ""}
          </label>
          <input
            type="tel"
            inputMode="tel"
            autoComplete="tel"
            value={phone}
            onChange={(e) => onPhoneChange(e.target.value)}
            className={inputClass}
            data-testid="staff-sms-phone"
          />
          <p className="text-[11px] font-['Manrope'] text-white/40 mt-1.5">
            Required only if you opt in to SMS notifications.
          </p>
        </div>
      )}

      <label
        className="flex items-start gap-3 p-3 border border-white/10 bg-white/[0.03] cursor-pointer"
        data-testid="staff-sms-opt-in-label"
      >
        <input
          type="checkbox"
          checked={!!smsOptIn}
          onChange={(e) => onSmsOptInChange(e.target.checked)}
          className={boxCls}
          data-testid="staff-sms-opt-in"
        />
        <span className="text-sm leading-relaxed font-['Manrope'] text-white/75">
          {STAFF_SMS_CONSENT_TEXT}{" "}
          <Link
            to="/privacy"
            target="_blank"
            rel="noopener noreferrer"
            className={linkCls}
            onClick={(e) => e.stopPropagation()}
          >
            Privacy Policy
          </Link>{" "}
          and{" "}
          <Link
            to="/terms"
            target="_blank"
            rel="noopener noreferrer"
            className={linkCls}
            onClick={(e) => e.stopPropagation()}
          >
            Terms and Conditions
          </Link>
          .
        </span>
      </label>

      {showTermsCheckbox && !termsAlreadyAccepted && (
        <label
          className="flex items-start gap-3 p-3 border border-white/10 bg-white/[0.03] cursor-pointer"
          data-testid="staff-terms-label"
        >
          <input
            type="checkbox"
            checked={!!acceptedTerms}
            onChange={(e) => onAcceptedTermsChange(e.target.checked)}
            className={boxCls}
            data-testid="staff-accept-terms"
          />
          <span className="text-sm leading-relaxed font-['Manrope'] text-white/75">
            I have reviewed and accept Drive Now Autohaus’s{" "}
            <Link
              to="/terms"
              target="_blank"
              rel="noopener noreferrer"
              className={linkCls}
              onClick={(e) => e.stopPropagation()}
            >
              Terms and Conditions
            </Link>{" "}
            and{" "}
            <Link
              to="/privacy"
              target="_blank"
              rel="noopener noreferrer"
              className={linkCls}
              onClick={(e) => e.stopPropagation()}
            >
              Privacy Policy
            </Link>
            .
          </span>
        </label>
      )}

      {termsAlreadyAccepted && (
        <p className="text-[11px] font-['Manrope'] text-white/40">
          You previously accepted our{" "}
          <Link to="/terms" target="_blank" rel="noopener noreferrer" className={linkCls}>
            Terms and Conditions
          </Link>{" "}
          and{" "}
          <Link to="/privacy" target="_blank" rel="noopener noreferrer" className={linkCls}>
            Privacy Policy
          </Link>
          .
        </p>
      )}
    </div>
  );
}
